import { Avatar, Box, Button, Menu, MenuItem } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { viewImage } from "../../utils/viewPDF";

function stringAvatar(name) {
  const parts = name.trim().split(" ");
  if (parts.length === 1) {
    return {
      children: parts[0][0].toUpperCase(),
    };
  } else {
    return {
      children: `${parts[0][0]}${parts[1][0]}`.toUpperCase(),
    };
  }
}

const UserNavbar = () => {
  const [user, setUser] = useState();
  const [org, setOrg] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [fileUrl, setFileUrl] = useState("");

  useEffect(() => {
    const getUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user?username=${storedUser.username}`,
          {
            headers: { Authorization: `Bearer ${storedUser.accessToken}` },
          }
        );
        setUser(res.data);
        if (!res.data.isEnable){
          localStorage.clear()
          navigate("/")
          return
        }
      } catch (error) {
        console.log(error);
      }
    };
    getUser();
  }, []);

  useEffect(() => {
      const getOrg = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/org-user/get-org?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          if(res.data.subscriptionEndDate < new Date().toISOString().split("T")[0]){
            alert("Your organization's subscription has ended. Please contact the admin.")
            localStorage.clear();
            navigate("/")
            return
          }
          setOrg(res.data);
          localStorage.setItem("org", JSON.stringify(res.data.orgId))
          // Get image URL
          if (res.data.orgLogo) {
            const url = await viewImage(res.data.orgLogo, storedUser);
            setFileUrl(url);
          }
        } catch (error) {
          console.error("Error fetching organization:", error);
        }
      };
      getOrg();
    }, []);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };
  return (
    <Box sx={{ background: "#ffffff" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 7,
        }}
      >
        <div>
          {org && <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
            {fileUrl &&
            <img
              src={fileUrl && fileUrl}
              alt="Organization Logo"
              style={{ height: 50 }}
            />}
            <p>{org.orgName}</p>
          </div>}

        </div>
        <Box sx={{ display: "flex", columnGap: 20 }}>
          <Button
            className="btn-outlined"
            sx={{
              padding: "5px 60px !important",
              border: "1px solid #1a71f6",
            }}
            onClick={() => navigate("/dashboard")}
          >
            Dashboard
          </Button>
          <Box sx={{ display: "inline-flex", alignItems: "center", gap: 2 }}>
            {user && user.name}
            <Avatar
              {...stringAvatar(`${user && user.name}`)}
              onClick={handleAvatarClick}
              sx={{ cursor: "pointer" }}
            />
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default UserNavbar;
